export const QA_AUTH_TOKEN = "qaAuthToken";
